module.exports = __webpack_public_path__ + "img/bg_process.a3149a43.png";